import React from "react";
import classNames from "classnames";
// types
import { TextInputProps } from "../../../types/components/dynamicForms/dynamicField";

/**
 * Presentational text/email input. Controlled, no react-hook-form awareness.
 * Renders the Bootstrap `.form-control` (vendor CSS) inside a bwp-field control
 * wrapper so existing input styling applies while layout/error live in FieldRow.
 */
const TextInput = ({
  id,
  value,
  onChange,
  onBlur,
  disabled,
  describedById,
  invalid,
  placeholder,
  type = "text",
  maxLength,
}: TextInputProps) => {
  return (
    <input
      id={id}
      type={type}
      className={classNames("form-control", "bwp-field__control", {
        "bwp-field__control--invalid": invalid,
      })}
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      disabled={disabled}
      maxLength={maxLength}
      placeholder={placeholder}
      aria-invalid={invalid || undefined}
      aria-describedby={describedById}
    />
  );
};

export default TextInput;